import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { equipmentObject, onboardingEquipmentObject, INameAllEquipmentData, connectedStrengthEquipmentDetails, cardioEquipmentDetails, ErrorCodesData } from './equipment.model';

@Injectable({
  providedIn: 'root'
})

export class EquipmentService {

  constructor(private httpClient: HttpClient, 
    private rootScopeService: RootScopeService, 
    private httpHeaderService: HttpHeadersService) { }

  public getEquipmentData(facilityId: string): Observable<equipmentObject> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/equipment?facilityId='+facilityId, { headers });
    return result as Observable<equipmentObject>;
  }

  public deleteEquipment(facilityId: string,bodySerial: string , equipmentType:string,assetId:string): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let result;
    if(equipmentType === 'strength'){
      result = this.httpClient.delete(environment.servicePath + '/equipment/assets?assetId='+assetId+'&facilityId='+facilityId, { headers });
    }else  if(equipmentType === 'smartInfra'){
      result = this.httpClient.delete(environment.servicePath + '/equipment/assets?bodySerial='+bodySerial+'&facilityId='+facilityId, { headers });
    }else{
      result = this.httpClient.delete(environment.servicePath + '/equipment/'+assetId, { headers });
    }
    return result as Observable<any>;
  }

  public nameEquipment(facilityId: string, bodySerial: string, name: string, equipmentType: string, equipmentModel: string, assetId:string,id:string): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let result;
    if(equipmentType === 'strength'){
      let payload = {
        "connectedStrengthAssetDetailsVO": [
            {
                "facilityId": Number(facilityId),
                "assetId": assetId,
                "nickName": name
            }
        ]
    }
      result = this.httpClient.put(`${environment.servicePath}/equipment/assets/update_by_name`, payload, { headers });
    }else if(equipmentType === 'smartInfra'){
      if(equipmentModel === 'gateway'){
        let payLoad =  {
          gatewayAssetDetailsVOList : [{
            facilityId:facilityId, 
            gatewaySerial : bodySerial,
            nickName : name,
          }]
        }
        result = this.httpClient.put(`${environment.servicePath}/equipment/smart_infra_assets/update_by_name`, payLoad, { headers });
      }else{
        let payLoad =  {
          waspAssetDetailsVOList : [{
            facilityId:facilityId, 
            waspsSerial : bodySerial,
            nickName : name,
          }]
        }
        result = this.httpClient.put(`${environment.servicePath}/equipment/smart_infra_assets/update_by_name`, payLoad, { headers });
      }
      
    }else{
      result = this.httpClient.post(`${environment.servicePath}/equipment/${id}`, name?{ name : name}:{}, { headers });
    }
    return result as Observable<any>;
  }

  async nameAllEquipment(facilityId: string, data: INameAllEquipmentData[]): Promise<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let assetDetails:any = [];
    data.forEach((e) => {
      assetDetails.push({
        bodySerial: e.bodySerial,
        facilityId: e.facilityId,
        id: e.id,
        name: e.name
      })
    })
    return this.httpClient.post(`${environment.servicePath}/equipment/${facilityId}/name`, { assetDetails : assetDetails}, { headers }).toPromise();
  }

  async nameAllConnectedStrengthEquipment(facilityId: string, data: INameAllEquipmentData[]): Promise<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let payload:any = [];
    data.forEach((e)=>{
      payload.push({
        facilityId:Number(facilityId),
        assetId: e.assetId,
        nickName: e.name
      });
    })

    return this.httpClient.put(`${environment.servicePath}/equipment/assets/update_by_name`, {connectedStrengthAssetDetailsVO:payload}, { headers }).toPromise();
  }

  async nameAllSmartInfraEquipment(facilityId: string, data: INameAllEquipmentData[]): Promise<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let gatewayAssetDetailsVOList:any = [];
    let waspAssetDetailsVOList: any = [];

    data.forEach((e)=>{
      if(e.equipmentModel === 'gateway'){
        gatewayAssetDetailsVOList.push({
          facilityId:facilityId,
          gatewaySerial: e.bodySerial,
          nickName: e.name
        });
      }else{
        waspAssetDetailsVOList.push({
          facilityId:facilityId,
          waspsSerial: e.bodySerial,
          nickName: e.name
        });
      }
    })

    let payLoad : any = {};
    if(gatewayAssetDetailsVOList.length>0)
    payLoad['gatewayAssetDetailsVOList'] = gatewayAssetDetailsVOList;
    if(waspAssetDetailsVOList.length>0)
    payLoad['waspAssetDetailsVOList'] = waspAssetDetailsVOList;
  
    return this.httpClient.put(`${environment.servicePath}/equipment/smart_infra_assets/update_by_name`, payLoad, { headers }).toPromise();
  }

  public getProductUrl(productId: number): Observable<{productPageUrl:string}> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/equipment/get_product_page_url?productId='+productId, { headers });
    return result as Observable<{productPageUrl:string}>;
  }

  public getOnboardingAuth(): Observable<{'authToken':string}> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/facility_maintenance/gaetoken', { headers });
    return result as Observable<{'authToken':string}>;
  }
  
  public getOnboardingEquipmentData(): Observable<onboardingEquipmentObject[]> {
    const headers = this.httpHeaderService.bearerIAPHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.appEngineServiceBasePath + '/v1/list_equipments_to_register/ip', { headers });
    return result as Observable<onboardingEquipmentObject[]>;
  }

  public postOnboardingEquipmentData(postData : any): Observable<any> {
    const headers = this.httpHeaderService.bearerIAPHttpAuthorizationHeader();
    const result = this.httpClient.post(environment.appEngineServiceBasePath + '/v1/use_external_ip',postData, { headers });
    return result as Observable<any>;
  }

  public deleteOnboardingEquipment(postData : [string]): Observable<any> {
    const headers = this.httpHeaderService.bearerIAPHttpAuthorizationHeader();
    const result = this.httpClient.post(environment.appEngineServiceBasePath + '/v1/list_equipments_to_unregister',postData, { headers });
    return result as Observable<any>;
  }

  public getEquipmentDetails(facilityId: string, assetId: string): Promise<connectedStrengthEquipmentDetails | any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let postData = {
      "facilityId": facilityId,
      "assetId": assetId
    }
    return this.httpClient.post(environment.servicePath + '/equipment/assets/view', postData, { headers }).toPromise();
  }

  public getCardioProductDetails(assetId: string): Promise<cardioEquipmentDetails | any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.gcpServicePath + '/equipment/cardio_equipment_details?asset_id=' + assetId, { headers }).toPromise();
  }

  public getErrorCodes(facilityID: string, assetId: string): Promise<ErrorCodesData | any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.gcpServicePath + '/equipment/error_codes_by_asset?facility_id=' + facilityID + '&asset_id=' + assetId, { headers }).toPromise();
  }

  public getServiceRequests(assetId: string, facility_id: string): Promise<cardioEquipmentDetails | any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.gcpServicePath + '/equipment/service_request_by_asset?asset_id=' + assetId + '&&facility_id=' + facility_id, { headers }).toPromise();
  }
}
